import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { masterStateSelectedAdvisorDataSelector } from '../../../store/master/selector';
import { sessionState } from '../../../store/session/atom';

/**
 * Hook to determine if the Cockpit page should be enabled.
 *
 * This hook returns true if the logged-in user is a partner
 * and their `idParceiro` field matches the `partnerId`
 * field in the master state.
 *
 * @returns Whether the master state partnerId matches the logged-in user's idParceiro
 */
export const useMismatchingPartner = () => {
  const { userProfile } = useRecoilValue(sessionState);
  const selectedAdvisorData = useRecoilValue(masterStateSelectedAdvisorDataSelector);
  let partnerIdInMasterState = selectedAdvisorData?.partnerId;

  if (partnerIdInMasterState === undefined) {
    partnerIdInMasterState = userProfile?.idParceiro;
  }

  const [isMismatchingPartner, setIsMismatchingPartner] = useState(
    partnerIdInMasterState !== userProfile?.idParceiro
  );

  useEffect(() => {
    setIsMismatchingPartner(partnerIdInMasterState !== userProfile?.idParceiro);
  }, [partnerIdInMasterState, userProfile?.idParceiro]);

  return isMismatchingPartner;
};
